module.exports = __webpack_public_path__ + "img/childpool2.36d14f25.svg";